import React from 'react'

import { Instrument } from '../../../types/shared'
import {
  Button,
  Dialog,
  DialogTrigger,
  Dropdown,
  DropdownItem,
  Icon,
  SaveToPortfolio,
  Search as WebsiteSearchComponent,
  useDialogState,
  useDropdownState,
} from '../../components'

interface SearchProps {
  ticker: string
  instrument: Instrument
  onTickerSelected: (ticker: string) => void
  chartIndex: number
}

export default function Search({ ticker, instrument, onTickerSelected, chartIndex }: SearchProps) {
  const dropdownState = useDropdownState({ placement: 'bottom-end' })
  const dialog = useDialogState()

  const detailLink = React.useMemo(() => {
    const formattedTicker = ticker.replace('@', '')

    switch (instrument) {
      case Instrument.Stock:
        return `/quote.ashx?t=${formattedTicker}`
      case Instrument.Futures:
        return `/futures_charts.ashx?t=${formattedTicker}`
      case Instrument.Forex:
        return `/forex_charts.ashx?t=${formattedTicker}`
      case Instrument.Crypto:
        return `/crypto_charts.ashx?t=${formattedTicker}`
    }
  }, [ticker, instrument])

  return (
    <div className="search flex w-32 flex-none items-center">
      <WebsiteSearchComponent
        chartIndex={chartIndex}
        placeholder={ticker}
        size="medium"
        inputClass="pr-7 placeholder:text-gray-900 focus:placeholder:text-gray-500 dark:placeholder:text-white dark:focus:placeholder:text-gray-400"
        isSearchIcon={false}
        isSearchItemLink={false}
        isShowAllVisible={false}
        onTickerSelected={onTickerSelected}
        rightContent={
          <Dropdown
            state={dropdownState}
            aria-label="More options"
            label={
              <Button
                type="button"
                size="none"
                className="h-full w-7 text-gray-400 hover:text-gray-500"
                theme="transparent"
                appearance="square"
                rightContent={<Icon width={20} name="more" />}
              />
            }
          >
            <DropdownItem as="a" target="_blank" href={detailLink}>
              {instrument === Instrument.Stock ? 'Open Stock Detail' : 'Open Detail'}
            </DropdownItem>
            {instrument === Instrument.Stock && (
              <DropdownItem as={DialogTrigger} state={dialog}>
                Save to Portfolio
              </DropdownItem>
            )}
            {instrument === Instrument.Stock && (
              <DropdownItem as="a" target="_blank" href={`/create_alert.ashx?t=${ticker}`}>
                Create Alert
              </DropdownItem>
            )}
          </Dropdown>
        }
      />
      <Dialog state={dialog} aria-label="Save to Portfolio" className="w-110">
        <SaveToPortfolio ticker={ticker} onClose={dialog.hide} />
      </Dialog>
    </div>
  )
}
